import {connect} from 'react-redux';
import {Checkbox} from "components/forms/BasicFormFields/index";
import {clone, isNoU} from "utils/DBUtils";

// Checkbox displays right to left, top to bottom
// So order is a bit weird here
// Probably need to support an option in checkbox to chose which direction to go eventually
const possibleOptions = [
    {
        textKey: "editbreak.steps.lead_gen.field.firstName",
        value: "firstName",
        key: "firstName"
    },
    {
        textKey: "editbreak.steps.lead_gen.field.age",
        value: "age",
        key: "age",
    },
    {
        textKey: "editbreak.steps.lead_gen.field.lastName",
        value: "lastName",
        key: "lastName"
    },
    {
        textKey: "editbreak.steps.lead_gen.field.gender",
        value: "gender",
        key: "gender",
    },
    {
        textKey: "editbreak.steps.lead_gen.field.fullName",
        value: "fullName",
        key: "fullName",
    },
    {
        textKey: "editbreak.steps.lead_gen.field.birthdayDay",
        value: "birthdayDay",
        key: "birthdayDay",
    },
    {
        textKey: "editbreak.steps.lead_gen.field.email",
        value: "email",
        key: "email",
    },
    {
        textKey: "editbreak.steps.lead_gen.field.birthdayMonth",
        value: "birthdayMonth",
        key: "birthdayMonth",
    },
    {
        textKey: "editbreak.steps.lead_gen.field.address",
        value: "address",
        key: "address",
    },
    {
        textKey: "editbreak.steps.lead_gen.field.birthdayYear",
        value: "birthdayYear",
        key: "birthdayYear",
    },
    {
        textKey: "editbreak.steps.lead_gen.field.address2",
        value: "address2",
        key: "address2",
    },
    {
        textKey: "editbreak.steps.lead_gen.field.largeText",
        value: "largeText",
        key: "largeText",
    },
    {
        textKey: "editbreak.steps.lead_gen.field.city",
        value: "city",
        key: "city",
    },
    {
        textKey: "editbreak.steps.lead_gen.field.customText1",
        value: "customText1",
        key: "customText1",
    },
    {
        textKey: "editbreak.steps.lead_gen.field.state",
        value: "state",
        key: "state",
    },
    {
        textKey: "editbreak.steps.lead_gen.field.customText2",
        value: "customText2",
        key: "customText2",
    },
    {
        textKey: "editbreak.steps.lead_gen.field.zipCode",
        value: "zipCode",
        key: "zipCode",
    },
    {
        textKey: "editbreak.steps.lead_gen.field.customText3",
        value: "customText3",
        key: "customText3",
    },
    {
        textKey: "editbreak.steps.lead_gen.field.phoneNumber",
        value: "phoneNumber",
        key: "phoneNumber",
    },
    {
        textKey: "editbreak.steps.lead_gen.field.image",
        value: "image",
        key: "image",
    },
    {
        textKey: "editbreak.steps.lead_gen.field.mobileNumber",
        value: "mobileNumber",
        key: "mobileNumber",
    },
];

const mapStateToProps = (state) => {
    let leadGen = state.leadGenFieldPicker.pickingForLeadGen;
    let existingFields = !isNoU(leadGen) && !isNoU(leadGen.fields)? leadGen.fields.filter(item => !item.deleted) : [];
    let options = clone(possibleOptions);

    if (!isNoU(existingFields)) {
        for (let existing of existingFields) {
            let field = options.find((item) => existing.name === item.key);
            field.disabled = true;
            field.preChecked = true;
        }
    }

    return {
        options: options
    }
};

export default connect(mapStateToProps, null)(Checkbox);


// WEBPACK FOOTER //
// ./public/pages/LeadGenFieldPicker/LeadGenFieldPickerCheckbox.jsx